// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"452":"36e92edf","470":"469396bf"}[chunkId] + ".chunk.css";
};